module.exports = __webpack_public_path__ + "static/puck-main-z29-123580f6b9ccfaa7d339c932ce1212c3.jpg";